import React from 'react';

import { RHP } from 'providers';
import { useConversionOptions } from 'hooks';
import { useForm } from 'components/form';

import * as Form from 'components/form';
import * as Page from 'components/page';

export function StartupStep2(props) {
    const { vars, putStartupRankingApplication, putStartupDetails } = props.useRankingStartup;
    const { startupDetails, ranking } = vars;

    const conv = useConversionOptions(['investmentOrRevenues'], { namespace: 'currencyUSD' });

    const currentDate = new Date();
    const pastYear = currentDate.getFullYear() - 1;

    if (!startupDetails.rankingData) {
        startupDetails.rankingData = {};
    }

    if (!startupDetails.rankingData?.[ranking.id]) {
        startupDetails.rankingData[ranking.id] = {
            revenuesRange: [],
            investmentRange: [],
            categories: [],
        };
    }

    // Initialize a new form handler
    const form = useForm({
        ...vars.application,
        startupName: startupDetails.name,
        shortDescription: startupDetails.description,
        revenuesRange: startupDetails.rankingData[ranking.id].revenuesRange,
        investmentRange: startupDetails.rankingData[ranking.id].investmentRange,
        isUpToDate: !!vars.application.appliedAt,
    });

    // Check for previous step conclusion
    if (!vars.application.steps || vars.application.steps.step1 !== true) {
        RHP.replace('/ranking/co/startup/');
        return null;
    }

    // Handle form submitions
    const onSubmit = values => {
        const rankingPayload = {
            ...vars.application,
            investmentRange: values.investmentRange,
            revenuesRange: values.revenuesRange,
        };
        // Set the current step to true;
        if (!rankingPayload.steps) rankingPayload.steps = {};
        rankingPayload.steps.step2 = true;

        const startupPayload = {
            description: values.shortDescription,
            name: values.startupName,
            language: startupDetails.language,
        };

        return putStartupDetails(startupPayload).then(
            putStartupRankingApplication(rankingPayload)
                .then(() => RHP.push('/ranking/co/startup/step3'))
                .catch(() => form.submited())
        );
    };

    const shortDescriptionLabel = {
        pt: `${props.t('glossary:shortDescription')} ${props.t('glossary:inPortuguese')}`,
        en: `${props.t('glossary:shortDescription')} ${props.t('glossary:inEnglish')}`,
        es: `${props.t('glossary:shortDescription')} ${props.t('glossary:inSpanish')}`,
    };

    const fields = {
        startupName: {
            error: form.errors.startupName,
            label: props.t('glossary:startupName'),
            name: 'startupName',
            type: 'generic',
            value: form.values.startupName,
            onChange: form.handleChange,
        },
        shortDescription: {
            error: form.errors.shortDescription,
            label: shortDescriptionLabel[startupDetails.language],
            name: 'shortDescription',
            type: 'textarea',
            value: form.values.shortDescription,
            onChange: form.handleChange,
        },
        revenuesRange: {
            error: form.errors.revenuesRange,
            label: `${props.t('glossary:revenuesRange')}`,
            name: 'revenuesRange',
            type: 'SelectRangeArray',
            options: [
                { name: props.t('glossary:selectOption'), value: '' },
                ...conv.investmentOrRevenues,
            ],
            value: form.values.revenuesRange,
            onChange: form.handleChange,
        },
        investmentRange: {
            error: form.errors.investmentRange,
            label: `${props.t('glossary:investmentRange')} 31/12/${pastYear}`,
            name: 'investmentRange',
            type: 'SelectRangeArray',
            options: [
                { name: props.t('glossary:selectOption'), value: '' },
                ...conv.investmentOrRevenues,
            ],
            value: form.values.investmentRange,
            onChange: form.handleChange,
        },
    };

    const evSubmit = ev => form.handleSubmit(ev, onSubmit);
    return (
        <Page.Page name="StartupStep2" back="/ranking/co/startup">
            <Page.Title>{props.t('StartupStep2.title')}</Page.Title>
            <Page.Descr>{props.t('StartupStep2.descr')}</Page.Descr>

            <Form.Form name="StartupStep2Form" onSubmit={evSubmit}>
                <Form.Field {...fields.startupName} />
                <Form.Field {...fields.shortDescription} />
                <Form.Field {...fields.revenuesRange} />
                <Form.Field {...fields.investmentRange} />
                <Form.Submt {...form} text={props.t('glossary:save')} />
            </Form.Form>
        </Page.Page>
    );
}
export default StartupStep2;
